jQuery(function($){
	var $helper = $('#wp_access_helper_container');
	var $skiplinks = $('.wah-skiplinks-menu');
	var $accessContainer = $('#access_container');
	var $bodyLinks;

	if (!$helper.length) {
		return;
	}

	if ($helper.parent()[0] !== document.body) {
		$helper.prependTo('body');
	}

	if ($skiplinks.length && $skiplinks.parent()[0] !== document.body) {
		$skiplinks.prependTo('body');
	}

	$helper.find('.aicon_link').css('display', 'inline-block');
	$accessContainer.find('button, a, .wah-free-credits a').attr('tabindex', '-1');
	$accessContainer.attr('aria-hidden', 'true');

	$bodyLinks = $('body a, body button');

	$helper.on('click', '.aicon_link', function(event){
		event.preventDefault();
		$helper.addClass('active');
		$accessContainer.find('button, a, .wah-free-credits a').removeAttr('tabindex');
		$accessContainer.attr('aria-hidden', 'false');
	});

	$helper.on('click', '.close_container, .close-wah-sidebar', function(event){
		event.preventDefault();
		$helper.removeClass('active');
		$accessContainer.find('button, a, .wah-free-credits a').attr('tabindex', '-1');
		$accessContainer.attr('aria-hidden', 'true');
	});

	if (typeof removeLinkTitles !== 'undefined' && removeLinkTitles == 1) {
		setTimeout(function(){
			$bodyLinks.each(function(){
				var $link = $(this);
				if ($link.attr('title')) {
					$link.removeAttr('title');
				}
			});
		}, 500);
	}

	if (typeof roleLink !== 'undefined' && roleLink == 1) {
		setTimeout(function(){
			$bodyLinks.each(function(){
				var $link = $(this);
				if (typeof Foundation !== 'undefined' && Foundation.version) {
					if ($link.attr('role') !== 'tab') {
						$link.attr('role', 'link');
					}
				} else {
					$link.attr('role', 'link');
				}
			});
		}, 500);
	}
});
